export function initFaq() {
    // One-at-a-time accordion, scoped per module
    document.querySelectorAll('.module--faq').forEach((module) => {
        const items = module.querySelectorAll('.faq__item');

        items.forEach((item) => {
            item.addEventListener('toggle', () => {
                if (item.open) {
                    items.forEach((other) => {
                        if (other !== item && other.open) {
                            other.open = false;
                        }
                    });
                }
            });
        });
    });

    // Deep-linking via URL hash
    const hash = window.location.hash;
    if (hash && hash.startsWith('#faq-')) {
        const target = document.querySelector(hash);
        if (target && target.tagName === 'DETAILS') {
            target.open = true;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}
